export enum FormStatusSurvey {
  EXPIRED = 'expired',
  INVALID = 'invalid',
  VALID = 'valid',
  PROCESSING = 'processing',
  PAID = 'paid',
  RENEW = 'renew',
}

export interface SurveySessionResponse {
  data: {
    uuid: string;
    message: string;
    status: FormStatusSurvey;
    additional_properties: {
      voucher_code: string,
      voucher: string,
      magazine_type: string,
    } | null,
  };
}
